<div class="timeline-bar">
  <button class="tl-btn tl-nav" (click)="prevFrame()" title="Previous frame">◀</button>

  <button class="tl-btn tl-play"
    [class.playing]="isPlaying"
    (click)="togglePlay()"
    [title]="isPlaying ? 'Stop' : 'Play'">
    {{ isPlaying ? '⏹' : '▶' }}
    <span>{{ isPlaying ? 'Stop' : 'Play' }}</span>
  </button>

  <button class="tl-btn tl-nav" (click)="nextFrame()" title="Next frame">▶</button>

  <span class="fps-label">FPS</span>
  <input type="range" class="fps-slider"
    [(ngModel)]="fps" min="1" max="24" (change)="onFpsChange()">
  <span class="fps-val">{{ fps }}</span>

  <div class="frame-counter">
    <span class="frame-cur">{{ (currentIndex$ | async)! + 1 }}</span>
    <span class="frame-sep">/</span>
    <span class="frame-tot">{{ frameCount$ | async }}</span>
  </div>
</div>
